import React from 'react';
import sports from '../../assests/img/sports.jpg';

const Sports = () => {

    return (
        <>
            <div className='inner_top_about_us'>
                <div id="bg" className="data-typography-1 data-theme-1">
                    <div className="page-wraper">
                        <div className="page-content bg-white">
                            <div className="dz-bnr-inr dz-bnr-inr-sm style-1 text-center overlay-primary-dark">
                                <div className="coustom_container">
                                    <div className="dz-bnr-inr-entry">
                                        <div className="pheading">
                                            <h1>Sports</h1>
                                        </div>
                                        <nav aria-label="breadcrumb" className="breadcrumb-row">
                                            <ul className="breadcrumb">
                                                <li className="breadcrumb-item">
                                                    <a href="/">Home</a>
                                                </li>
                                                <li className="mx-2">
                                                    /
                                                </li>
                                                <li className="breadcrumb-item active" aria-current="page">
                                                    Sports
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>
                                </div>
                            </div>


                            <section className="content-inner section-wrapper5 pt-5 pb-5">
                                <div className="coustom_container">
                                    <div className="row">
                                        <div
                                            className="col-xl-9 col-lg-6 m-b30 wow fadeInUp"
                                            data-wow-delay="0.4s"
                                        >
                                            <div id="pagedata" className="pagedata">
                                                <p style={{ textAlign: "justify" }}>
                                                    <img src={sports} alt="sports" width="100%" />
                                                </p>
                                                <p style={{ textAlign: "justify" }}>
                                                    In order to keep our young talents full of life and vigour, we aim to encourage and organise lots of sports activity in the school. The list which is not exhaustive includes athletics, cricket, football, basketball, badminton, kabaddi, kho-kho and many more. The institute will organise sports events every year for the students. We believe in healthy hearts and strong minds.
                                                </p>
                                            </div>
                                        </div>

                                        <div
                                            className="col-xl-3 col-lg-6 wow fadeInUp"
                                            data-wow-delay="0.2s"
                                        >
                                            <div className="bg-lgrey">
                                                <div className="subMenubg active">
                                                    <a href="smart-classrooms" target="_self" className="submenu">
                                                        Smart Classrooms
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a
                                                        href="library"
                                                        target="_self"
                                                        className="submenu"
                                                    >
                                                        Library
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a href="computer-lab" target="_self" className="submenu">
                                                        Computer Lab
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a href="science-lab" className="submenu">
                                                        Science Lab
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a href="sports" target="_self" className="submenu">
                                                        Sports
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a
                                                        href="transport"
                                                        target="_self"
                                                        className="submenu"
                                                    >
                                                        Transport
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a
                                                        href="skill-lab"
                                                        target="_self"
                                                        className="submenu"
                                                    >
                                                        Skill Lab
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a
                                                        href="school-clubs"
                                                        target="_self"
                                                        className="submenu"
                                                    >
                                                        School Clubs
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>

                        <button className="scroltop icon-up" type="button">
                            <i className="fas fa-arrow-up"></i>
                        </button>
                    </div>
                </div>
            </div >
        </>
    )
}

export default Sports;